import * as React from "react"
export const Swap = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props}>
        <path fill="none" d="M0 0h256v256H0z" />
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={16}
            d="M80 160h128a8 8 0 0 0 8-8V48a8 8 0 0 0-8-8H96a8 8 0 0 0-8 8v8"
        />
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={16}
            d="m104 136-24 24 24 24"
        />
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={16}
            d="M176 96H48a8 8 0 0 0-8 8v104a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-8"
        />
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={16}
            d="m152 120 24-24-24-24"
        />
    </svg>
)
